export const EN_T = {
  HELLO: "Hello",
  STARTER: "Everything going start here !",

  OPERATIONS_MANAGEENT: "Operations management",
  SALE_OPERATIONS_MANAGEMENT: "Sales oeparations management",
};
